export const CHIP_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  TEAM: 'TEAM',
};

export const CHIP_TOOLTIP_TEXT = {
  MAIN_CONTACT_NO_ROLE: 'Der Hauptkontakt wird nicht mit der Beteiligtenrolle synchronisiert.',
  AGENT_NO_ROLE: 'Der Kontakt wird nicht mit den Beteiligtenrollen synchronisiert.',
  TEAM_NO_ROLE: 'Das Team wird nicht mit den Beteiligtenrollen synchronisiert.',
  ROLE_NO_AGENT: 'Es gibt bei diesem Kunden keinen Mitarbeiter mit dieser Beteiligtenrolle.',
  ROLE_NO_TEAM: 'Es gibt bei diesem Kunden kein Team mit dieser Beteiligtenrolle.',
  CRM_SYNCHED_FIRST:
    'Aus technischen Gründen wird pro Beteiligtenrolle eines Kunden nur ein Ansprechpartner importiert.',
  BEEM_MANUALLY_ADDED: 'Beteiligtenrolle existiert nur in BEEM (kein CRM-Sync).',
};

export const NAME_PLACEHOLDERS = {
  ROLE_NO_AGENT: 'Kein Mitarbeiter',
  ROLE_NO_TEAM: 'Kein Team',
};

export const ROLE_STATUS = {
  MEMBER_NO_ROLE: 'MEMBER_NO_ROLE',
  ROLE_NO_MEMBER: 'ROLE_NO_MEMBER',
  MEMBER_WITH_ROLE: 'MEMBER_WITH_ROLE',
};

export const ROLE_TO_RESPONSIBILITY_TOOLTIP = {
  // Roles where the first agent is synched with CRM data
  Angebotsverfolger: CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  Ausstellungsmitarbeiter: CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'Digital Coach': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  Kreditsachbearbeiter: CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'NFG - Key Account Manager': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'Objekt- / Kalkulationsabteilung': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Brötje': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Dachtechnik': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Datennetzwerktechnik': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Gebäudetechnik': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Hausgeräte': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Heizung': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Industrie': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Installation': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Isolierung/Befestigung/Brandsch.': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Kabel / Leitungen': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Klima / Lüftung': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Licht': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Regenerative Energien': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Sanitär': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Schaltanlagen': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Schwimmbad / Pumpen': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Tiefbau': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Versorgung': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Werkzeug': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'VAM Zuständiger Mitarbeiter - Vertrieb': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Entsorgung': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'E-Business Consultant': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  'TVK Samsung': CHIP_TOOLTIP_TEXT.CRM_SYNCHED_FIRST,
  // Roles that are managed in BEEM
  ABEX: CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'ABEX Springer': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'ABEX Springer 1': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'ABEX Springer 2': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'ABEX Springer 3': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'Ansprechpartner beim Partner': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'Innendienstmitarbeiter Springer': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'Innendienstmitarbeiter Springer 2': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'Innendienstmitarbeiter Springer 3': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  PhG: CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  Prokurist: CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'Teammitglied des Kunden': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'TVK Bedachung': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'TVK Duschkabinen': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  'TVK Photovoltaik': CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  Verkaufsleitung: CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
  Langzeitvertretung: CHIP_TOOLTIP_TEXT.BEEM_MANUALLY_ADDED,
};
